<template>
  <div class="itemlist">
<v-card>
  <v-card-title>
    <img src="../../../static/images/icon8icons/icons8-paint-palette-50.png" />
    <h1>Items</h1>
    <v-spacer/>

    <v-btn @click='addItem' color="accent">Add Item</v-btn>
  </v-card-title>

  <v-data-table
    :headers="headers"
    :items="computedItems"
    class="elevation-1"
  >
    <template
      slot="items"
      slot-scope="props"
    >
      <tr @click="viewItem(props.item)" style="cursor: pointer">
        <!-- td class="body-2 text-xs-left">{{ props.item.categoryName }}</td -->
        <td class="body-2 text-xs-left">{{ props.item.name }}</td>
        <td class="body-2 text-xs-left">{{ props.item.quantity }}</td>
        <td class="body-2 text-xs-left">{{ formatCurrency(props.item.price) }}</td>
        <td class="text-xs-right">
                  <v-icon
                    small
                    class="mr-2"
                    @click.stop='editItem(props.item)'
                  >
                    {{$vuetify.icons.edit}}
                  </v-icon>
                  <v-icon
                    small
                    @click.stop="deleteItem(props.item)"
                  >
                    {{$vuetify.icons.delete}}
                  </v-icon>
                </td>
      </tr>
    </template>
  </v-data-table>
  <div class="error--text" v-if="errMessage != null">
    {{errMessage}}
  </div>

</v-card>

      <hr />
      <ReturnToDashboard></ReturnToDashboard>

</div>

</template>

<script>
import {mapState} from 'vuex'
import utils from '../../utils.ts'
import ReturnToDashboard from './ReturnToDashboard'

export default {
  name: 'Items',
  components: {
    ReturnToDashboard
  },
  data () {
    return {
      loading: false,
      errMessage: null,
      headers: [
        // {text: 'Category', value: 'category', align: 'left'},
        {text: 'Name', value: 'name', align: 'left'},
        {text: 'Quantity', value: 'quantity', align: 'left'},
        {text: 'Price', value: 'price', align: 'left'},
        {text: 'Actions', value: 'actions', align: 'right'}
      ]
    }
  },
  computed: {
    ...mapState({
      items: state => state.admin.items,
      categories: state => state.admin.categories
    }),
    computedItems: function () {
      const newItems = this.items
      for (let i = 0; i < this.items.length; i++) {
        const cid = this.items[i].category
        let categoryName
        if (cid) {
          categoryName = this.getCategoryName(cid)
        } else {
          categoryName = 'Not set'
        }
        newItems[i].categoryName = categoryName
      }
      return newItems
    }

  },
  mounted: function () {
    // console.log('ITEMS: ' + this.items)
    // console.log('ComputedITEMS: ' + JSON.stringify(this.computedItems))
  },
  methods: {
    formatCurrency: function (c) {
      return utils.formatCurrency(c)
    },
    getCategoryName (cid) {
      if (!cid) return 'Not set'
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id === cid) {
          return this.categories[i].name
        }
      }
      return 'Not found'
    },
    deleteItem: function (item) {
      this.errMessage = null
      try {
        this.$confirm(`Do you really want to this item "${item.name}"?`).then(res => {
          if (res) {
            try {
              this.$store.dispatch('admin/deleteItem', {'iid': item.id}).catch( (err) => {
                  this.errMessage = err.message
              })
            } catch (err) {
              this.errMessage = err.message
            }
          }
        })
      } catch (err) {
        this.errMessage = err.message
      }
    },
    editItem: function (item) {
      // this.$emit('editItem', item)
      this.$router.push({name: 'addedititem', params: item})
    },
    viewItem: function (item) {
      this.$router.push({path: '/artists/viewitem/' + item.id})
    },
    addItem: function () {
      this.editItem(null)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.itemlist {
  width: 100%;
}

</style>
